import React, { useState, useEffect, useRef } from 'react';

const FullGallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);
  const [numCols, setNumCols] = useState(3);
  const containerRef = useRef(null);

  const galleryItems = [
    { id: 1, src: '/images/gallery/criadero_aro_miel.webp', desc: 'Excelente criadero cargado de criadero y su aro de Miel.' },
    { id: 2, src: '/images/gallery/aro_miel_cria.webp', desc: 'Un bastidor bien hecho, aro de miel y criadero' },
    { id: 3, src: '/images/gallery/bastidor_con_miel.webp', desc: 'Un bastidor bien sellado con miel.' },
    { id: 4, src: '/images/gallery/armando_colmena_blanca.webp', desc: 'Con estos hermosos criaderos armamos nuestras colmenas' },
    { id: 5, src: '/images/gallery/colmena_paisaje_verde.webp', desc: 'En medio de la naturaleza se encuentra nuestra colmena.' },
    { id: 6, src: '/images/gallery/bastidor_repleto_criadero.webp', desc: 'Así se ve un bastidor repleto de criadero.' },
    { id: 7, src: '/images/gallery/abeja_flor_limon.webp', desc: 'Abeja en una flor de limón.' },
    { id: 8, src: '/images/gallery/abeja_flor_tacote.webp', desc: 'Abeja en una flor de tacote' },
    { id: 9, src: '/images/gallery/abeja_mezquite.webp', desc: 'Las abejas recolectando nectar de los mezquites.' },
    { id: 10, src: '/images/gallery/raspando_propoleo_campo.webp', desc: 'Raspando Própoleo en los Apiarios, rodeado de naturaleza.' },
    { id: 11, src: '/images/gallery/colmena_abejas.webp', desc: 'Colmena jumbo repleta de abejas.' },
    { id: 12, src: '/images/gallery/abejas_dentro_flor_pitayo.webp', desc: 'Abejas en una flor de pitayo.' },
    { id: 13, src: '/images/gallery/pintando_reyna2025.webp', desc: 'Pintando una Reina año 2025.' },
    { id: 14, src: '/images/gallery/criadero_nucleo.webp', desc: 'Núcleo con buenos criaderos.' },
    { id: 15, src: '/images/gallery/agarrando_bastidor_criadero.webp', desc: 'Agarrando un bastidor con criadero.' },
    { id: 16, src: '/images/gallery/varroas_muertas.webp', desc: 'Varroas muertas en una colmena.' },
    { id: 17, src: '/images/gallery/piquera_vertical.webp', desc: 'La piquera de una colmena.' },
    { id: 18, src: '/images/gallery/reina_sin_marcar.webp', desc: 'Reina Ligustica X Carniola sin marca' },
    { id: 19, src: '/images/gallery/21_appiz_presidenta.webp', desc: 'La mtra. Nancy Toscano Presidenta Municipal en el 21 Aniversario de AAPIZ.' },
    { id: 20, src: '/images/gallery/colmenas_para_entregar_camioneta.webp', desc: 'Colmenas para entregar en camioneta' },
    { id: 21, src: '/images/gallery/colmena_para_entrega.webp', desc: 'Colmenas para entregar.' },
    { id: 22, src: '/images/gallery/nucleo_entrega.webp', desc: 'Así queda ya listo un núcleo para entregar.' },
    { id: 23, src: '/images/gallery/propoleo_tapa.webp', desc: 'Propóleo en una tapa. Despues de ser raspado.' },
    { id: 24, src: '/images/gallery/reina_bastidor_miel.webp', desc: 'Hermosa Reina Ligustica X Carniola con bastidor repleto de miel.' },
    { id: 25, src: '/images/gallery/abeja_higuerilla.webp', desc: 'Abeja en una flor de higuerilla.' },
    { id: 26, src: '/images/gallery/colmenas_alzas_miel.webp', desc: 'Colmenas con doble alza de miel.' },
    { id: 27, src: '/images/gallery/mano_abejas.webp', desc: 'La mano del Sr. Victor Preciado Sosteniendo abejas.' },
    { id: 28, src: '/images/gallery/expo_miel_2006.webp', desc: 'Expo miel 2006, con el Sr. Victor Preciado, su esposa la Sra. Elena Leonor y su hijo Victor Preciado Jr. exponiendo mieles de la asociacion AAPIZ.'},
    { id: 29, src: '/images/gallery/bastidor_2006.webp', desc: 'Así salieron los bastidores en la cosecha de octubre del 2006.' },
    { id: 30, src: '/images/gallery/apiarios_cipriano_preciado.webp', desc: 'En memoria del Sr. Cipriano Preciado, miembro fundador de AAPIZ y padre del Sr. Victor Preciado, en sus apiarios. Esta foto fue tomada en el año 2006.' },
    { id: 31, src: '/images/gallery/analizando_intestinos_abejas_2005.webp', desc: 'Analizando los intestinos de abejas para revisión de enfermedades, en el año 2005.' },
    { id: 32, src: '/images/gallery/donah_and_tomas_2024.webp', desc: 'Desde Rust Texas, nos visita Donah y Thomas Beavers, quienes tambien son apicultores en Estados Unidos, compartiendo experiencias y compartiendo entre nosotros la pasión por las abejas. Esta foto fue tomada en el año 2024 en la tienda de Productos Apícolas Artesanales.' },
    { id: 33, src: '/images/gallery/alimentador_colmenas_2017.webp', desc: 'Una colmena muy fuerte, le añadimos una alza para poder ponerle su alimentador con su jarabe de azúcar.' },
    { id: 34, src: '/images/gallery/expo_agricola_cdguzman_2012.webp', desc: 'Exponiendo en la Expo Agrícola 2012, en el municipio de Zapotlan el Grande, Jalisco (Ciudad Guzmán).' },
    { id: 35, src: '/images/gallery/extractor_noviembre_2013.webp', desc: 'Nuestro extractor eléctrico listo para sacar de los panales la miel.' },
    { id: 36, src: '/images/gallery/nucleos_2012.webp', desc: 'Así se miraba uno de nuestros apiarios allá por el año 2012. Preparando algunos núcleos para entregar a un cliente' },
    { id: 37, src: '/images/gallery/reyna_ligustica_2014.webp', desc: 'Una Abeja Reina allá por el año 2014, lista para iniciar a poner criadero.' },
    { id: 38, src: '/images/gallery/toyota_castra_octubre_2013.webp', desc: 'Así cargamos nuestra Pickup todo terreno, parte de la cosecha de octubre de 2013' },
    { id: 39, src: '/images/gallery/castra_octubre_2006_cipriano.webp', desc: 'El sr. Cipriano Preciado allá por el año 2006, extractando la miel en su sala de extracción en su rancho' },
    { id: 40, src: '/images/gallery/colmenas_invernadero_2018.webp', desc: 'En el año 2018 algunas de nuestras colmenas las rentamos en un invernadero para polinazación de berries' },
    { id: 41, src: '/images/gallery/cuchillo_vapor_2006.webp', desc: 'El sr. Victor Preciado, desoperculando bastidores llenos de miel, con un cuchillo de vapor.' },
    { id: 42, src: '/images/gallery/colmena_doble_alza_2015.webp', desc: 'Colmena con doble alza de miel, año 2015.' },
    { id: 43, src: '/images/gallery/curso_velas_2011.webp', desc: 'Curso de velas de cera de abeja en el año 2011. En la foto aparece el Sr. Victor Preciado, su esposa y su hija.' },
    { id: 44, src: '/images/gallery/emilio_gonzalez_2011.webp', desc: 'El Sr. Victor Preciado entregandole una canasta de productos derivados de las abejas al exgobernador de Jalisco Emilio González, en el año 2011.' },
    { id: 45, src: '/images/gallery/emilio_gonzalez_2011_2.webp', desc: 'El sr. Victor Preciado y su esposa Elena Leonor con el exgobernador de Jalisco Emilio González, en el año 2011. Muy agradecidos con el por apoyarnos con instructores y maestros para aprender a elaborar Productos a partir de los derivados de las abejas.' },
    { id: 46, src: '/images/gallery/etiquetando_jarabes_2006.webp', desc: 'El sr. Victor Preciado etiquetando jarabes de miel en el año 2006.' },
    { id: 47, src: '/images/gallery/expo_agosto_2010.webp', desc: 'Expo-Venta Agosto 2010.' },
    { id: 48, src: '/images/gallery/extractor_noviembre_2013.webp', desc: 'Así se mira nuestro extractor eléctrico cargado de bastidores llenos de miel, en el año 2013.' },
    { id: 49, src: '/images/gallery/mesa_desopercular_2013.webp', desc: 'Mesa para desoperculación de bastidores, año 2013.' },
    { id: 50, src: '/images/gallery/victor_apiario_2006.webp', desc: 'El sr. Victor Preciado en el apiario en el año 2006.' },
    { id: 51, src: '/images/gallery/victor_bastidor_cosecha_2015.webp', desc: 'El sr. Victor Preciado con un bastidor de miel en la cosecha de octubre de 2015.' },
    { id: 52, src: '/images/gallery/victor_revisando_bastidor_cosecha_2015.webp', desc: 'El sr. Victor Preciado revisando un bastidor de miel en la cosecha de octubre de 2015.' },
    { id: 53, src: '/images/gallery/alza_miel_2017.webp', desc: 'Una alza repleta de bastidores con miel lista para ser coscehada, en octubre de 2017.' },
    { id: 54, src: '/images/gallery/apiario_2006.webp', desc: 'Apiario en el año 2006.' },
    { id: 55, src: '/images/gallery/apiario_2013.webp', desc: 'Apiario en el año 2013.' },
    { id: 56, src: '/images/gallery/apiario_frente_2013.webp', desc: 'Apiario en el año 2013, vista frontal.' },
    { id: 57, src: '/images/gallery/bastidor_octubre_2017.webp', desc: 'Bastidor de miel en octubre de 2017.' },
    { id: 58, src: '/images/gallery/carpinteria_2015.webp', desc: 'El sr. Victor Preciado en su carpintería, cepillando tablas para armar cubos jumbo para las colmenas, en el año 2015.' },
    { id: 59, src: '/images/gallery/carpinteria_2015_2.webp', desc: 'El sr. Victor Preciado en su carpintería, todo el material de madera para sus colmenas es elaborado por el Sr. Victor Preciado, foto en el año 2015.' },
    { id: 60, src: '/images/gallery/cipriano_extractor_2006.webp', desc: 'El sr. Cipriano Preciado con su extractor manual en la cosecha de octubre de 2006.' },
  ];

  useEffect(() => {
    const calculateColumns = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const windowWidth = window.innerWidth;

        let hexWidth = 200; 
        if (windowWidth <= 480) hexWidth = 130;
        else if (windowWidth <= 768) hexWidth = 160;

        const cols = Math.floor((containerWidth - hexWidth) / (hexWidth * 0.75)) + 1;
        setNumCols(cols > 0 ? cols : 1);
      }
    };

    calculateColumns();
    window.addEventListener('resize', calculateColumns);
    return () => window.removeEventListener('resize', calculateColumns);
  }, []);

  const columns = Array.from({ length: numCols }, () => []);
  galleryItems.forEach((item, index) => {
    columns[index % numCols].push(item);
  });

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % galleryItems.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + galleryItems.length) % galleryItems.length);
  };

  const flatTopHexagon = 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)';

  return (
    <div className="min-h-screen bg-[#FFFBF0] dark:bg-[#1C1B17] py-20 px-4 transition-colors duration-300">
      <div className="max-w-[1400px] mx-auto w-full" ref={containerRef}>
        
        <header className="text-center mb-16">
          <h1 className="text-4xl md:text-7xl font-black text-[#594400] dark:text-[#FFD54F] uppercase tracking-tighter">
            Nuestro Panal de Recuerdos
          </h1>
          <p className="text-[#A68900] font-bold mt-2">Cada aventura, cada día de trabajo lo vamos depositando en este panal de recuerdos, que es nuestra galería. Aquí podrás ver momentos especiales, desde el cuidado de nuestras colmenas hasta la belleza de las abejas en su entorno natural. Cada imagen es un testimonio de nuestra pasión por la apicultura y el amor por las abejas. ¡Explora nuestro panal y descubre!</p>
        </header>

        <div className="honeycomb-container flex justify-center items-start pb-24">
          {columns.map((col, colIndex) => (
            <div 
              key={`col-${colIndex}`}
              className="flex flex-col"
              style={{ 
                marginTop: colIndex % 2 !== 0 ? 'calc(var(--hex-height) * 0.5)' : '0',
                marginLeft: colIndex > 0 ? 'calc(var(--hex-width) * -0.25)' : '0'
              }}
            >
              {col.map((item) => {
                const realIndex = galleryItems.findIndex(g => g.id === item.id);
                return (
                  <div 
                    key={item.id}
                    onClick={() => setCurrentIndex(realIndex)}
                    className="hex-cell group relative cursor-pointer transition-transform duration-300 hover:scale-105 hover:z-50"
                  >
                    <div className="absolute inset-0 bg-white dark:bg-[#2A2821] shadow-md z-0" 
                         style={{ clipPath: flatTopHexagon }}></div>
                    
                    <div className="absolute inset-0 z-10 scale-[0.96] overflow-hidden transition-all duration-500 group-hover:scale-[0.98] group-hover:brightness-110"
                         style={{ clipPath: flatTopHexagon }}>
                      <img 
                        src={item.src} 
                        alt={`Panal ${item.id}`} 
                        className="w-full h-full object-cover scale-110 group-hover:scale-100 transition-transform duration-700" 
                      />
                      <div className="absolute inset-0 bg-yellow-500/10 group-hover:bg-transparent transition-colors"></div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* 🖼️ MODAL GRANDE CON NAVEGACIÓN */}
      {currentIndex !== null && (
        <div 
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black/95 backdrop-blur-sm animate-fade-in"
          onClick={() => setCurrentIndex(null)}
        >
          {/* BOTÓN DE CERRAR */}
          <button 
            onClick={() => setCurrentIndex(null)}
            className="absolute top-4 right-4 md:top-6 md:right-8 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FFD54F] text-white hover:text-black text-3xl font-light hover:scale-110 transition-all z-50 pb-1"
          >
            &times;
          </button>

          {/* CONTENEDOR PRINCIPAL DEL MODAL */}
          <div className="relative flex flex-col items-center justify-center w-full h-full max-w-[100vw] p-2 md:p-0">
            
            {/* IMAGEN (Adaptable a móvil y PC) */}
            <div 
              className="relative flex justify-center items-center w-full h-[70vh] md:h-[95vh] px-0 md:px-24"
              onClick={(e) => e.stopPropagation()} 
            >
              <img 
                src={galleryItems[currentIndex].src} 
                alt="Detalle" 
                className="w-full h-full object-contain drop-shadow-2xl" 
              />
              
              {/* PC ONLY: PIE DE FOTO FLOTANTE */}
              <div className="hidden md:flex absolute bottom-8 bg-black/70 backdrop-blur-md px-6 py-3 rounded-full border border-white/10 shadow-lg max-w-[70%] text-center pointer-events-none flex-col items-center justify-center">
                <p className="text-white/95 text-sm font-light tracking-wide drop-shadow-md">
                  {galleryItems[currentIndex].desc}
                </p>
                <div className="flex items-center justify-center gap-2 mt-2 w-full">
                  <span className="h-[1px] flex-1 max-w-[1rem] bg-[#FFD54F]/50"></span>
                  <p className="text-[#FFD54F] text-xs font-mono uppercase tracking-widest whitespace-nowrap">
                    {currentIndex + 1} / {galleryItems.length}
                  </p>
                  <span className="h-[1px] flex-1 max-w-[1rem] bg-[#FFD54F]/50"></span>
                </div>
              </div>
            </div>

            {/* PC ONLY: FLECHAS CENTRADAS A LOS COSTADOS */}
            <button 
              onClick={prevImage}
              className="hidden md:flex absolute left-4 md:left-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-[#FFD54F] bg-black/40 hover:bg-black/80 rounded-full w-14 h-14 items-center justify-center text-3xl hover:scale-110 transition-all backdrop-blur-sm z-50"
            >
              &#10094;
            </button>
            <button 
              onClick={nextImage}
              className="hidden md:flex absolute right-4 md:right-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-[#FFD54F] bg-black/40 hover:bg-black/80 rounded-full w-14 h-14 items-center justify-center text-3xl hover:scale-110 transition-all backdrop-blur-sm z-50"
            >
              &#10095;
            </button>

            {/* MOBILE ONLY: CONTROLES DEBAJO DE LA IMAGEN */}
            <div 
              className="md:hidden flex w-full items-center justify-between px-1 mt-4 max-w-[500px]"
              onClick={(e) => e.stopPropagation()} 
            >
              <button 
                onClick={prevImage}
                className="text-white/70 active:text-[#FFD54F] bg-black/40 active:bg-black/80 rounded-full w-12 h-12 flex items-center justify-center text-2xl transition-all backdrop-blur-sm shrink-0"
              >
                &#10094;
              </button>

              <div className="bg-black/60 backdrop-blur-md px-4 py-4 rounded-2xl border border-white/10 shadow-lg w-full mx-2 flex flex-col items-center text-center justify-center">
                {/* AUMENTADO: text-base sm:text-lg para mejor legibilidad en móvil */}
                <p className="text-white/95 text-base sm:text-lg font-medium tracking-wide drop-shadow-md leading-snug">
                  {galleryItems[currentIndex].desc}
                </p>
                <p className="text-[#FFD54F] text-xs font-bold uppercase tracking-widest mt-2">
                  {currentIndex + 1} / {galleryItems.length}
                </p>
              </div>

              <button 
                onClick={nextImage}
                className="text-white/70 active:text-[#FFD54F] bg-black/40 active:bg-black/80 rounded-full w-12 h-12 flex items-center justify-center text-2xl transition-all backdrop-blur-sm shrink-0"
              >
                &#10095;
              </button>
            </div>

          </div>
        </div>
      )}

      <style jsx>{`
        .honeycomb-container {
          --hex-width: 200px;
          --hex-height: calc(var(--hex-width) * 0.866);
        }

        @media (max-width: 768px) {
          .honeycomb-container {
            --hex-width: 160px;
          }
        }

        @media (max-width: 480px) {
          .honeycomb-container {
            --hex-width: 130px;
          }
        }

        .hex-cell {
          width: var(--hex-width);
          height: var(--hex-height);
          margin-bottom: 0;
        }

        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fade-in { animation: fade-in 0.3s ease-out; }
      `}</style>
    </div>
  );
};

export default FullGallery;